module.exports = __webpack_public_path__ + "img/HARLEY.0fe20cb.jpg";